/**
 * Zip entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class Zip extends BaseModel {
    defaults() {
        return {
            onrp: null,
            type: null,
            zip: null,
            extra_nr: null,
            city_short: null,
            city_long: null,
            canton: null,
            country_code: null,

            // view fields
            region_ids: null,
            regions: null,
        };
    }

    mutations() {
        return {
            onrp: Number,
            type: Number,
            zip: Number,
            extra_nr: Number,
        };
    }

    options() {
        return {
            identifier: 'onrp',
        };
    }

    entityName() {
        return 'Zip';
    }
}

export class ZipCollection extends BaseCollection {
    options() {
        return {
            model: Zip,
        };
    }

    entityName() {
        return 'Zip';
    }
}
